import React from 'react';

// TODO: RN Web - Implement widget
const VideoWidget: React.VFC = () => {
  return null;
};

export default VideoWidget;
